<div [formGroup]="form" class="modalForm">
  <div class="flex flex-column gap-2 mb-3">
    <label for="languageName" class="font-semibold w-full">
      {{ "fault_allocation.fault_lists.language_management.language_name" | translate }}</label
    >
    <input pInputText formControlName="languageName" id="languageName" autocomplete="off" />
  </div>
  <div class="flex flex-column gap-2 mb-3">
    <label for="languageCode" class="font-semibold w-full">
      {{ "fault_allocation.fault_lists.language_management.language_code" | translate }}</label
    >
    <input
      pInputText
      [readOnly]="actionType === 'edit'"
      formControlName="languageCode"
      id="languageCode"
      autocomplete="off"
    />
  </div>
  <div class="flex flex-column gap-2 mb-3">
    <label for="languageData" class="font-semibold w-full">
      {{ "fault_allocation.fault_lists.language_management.language_data" | translate }}</label
    >
    <input pInputText formControlName="languageData" id="languageData" autocomplete="off" />
  </div>
  <div class="flex justify-content-end gap-2 dialogBtnGroup">
    <app-button buttonText="common.cancel" (click)="closeDialog()"></app-button>
    <app-button buttonText="common.save" [disabled]="!form.valid" (click)="saveLanguage()"></app-button>
  </div>
</div>
